import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { IconPlus } from '@tabler/icons-react';
import { Button, IconButton, useMediaQuery } from '@wapharma/design-system';
import styles from './HeaderPrimaryButton.module.css';

const HEADER_NARROW_MQ = '(max-width: 47.99em)';

export type HeaderPrimaryButtonProps = {
  label: string;
  icon?: ReactNode;
} & Omit<ComponentPropsWithoutRef<'button'>, 'children'>;

export function HeaderPrimaryButton({
  label,
  icon = <IconPlus size={18} stroke={1.5} aria-hidden />,
  type = 'button',
  disabled,
  onClick,
  ...rest
}: HeaderPrimaryButtonProps) {
  const narrow = useMediaQuery(HEADER_NARROW_MQ);

  if (narrow) {
    return (
      <IconButton
        type={type}
        variant="primary"
        size="sm"
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
        {...rest}
      >
        {icon}
      </IconButton>
    );
  }

  return (
    <Button type={type} variant="primary" disabled={disabled} onClick={onClick} {...rest}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <span className={styles.leadingIcon}>{icon}</span>
        {label}
      </span>
    </Button>
  );
}
